import QRCode from "react-qr-code";
import { useTranslation } from "@/contexts/LanguageContext";
import { ImagesSquare, ArrowUpRight } from "@phosphor-icons/react";

const GALERIA_URL = "https://galeriasocial.com";

const COPY = {
  en: {
    tag: "From the same author",
    title: "Galería Social",
    subtitle: "A photography gallery + social platform — share, discover, and inspire.",
    visit: "Visit galeriasocial.com",
    scan: "Scan to open on your phone",
  },
  es: {
    tag: "Del mismo autor",
    title: "Galería Social",
    subtitle: "Una galería fotográfica + plataforma social — comparte, descubre e inspira.",
    visit: "Visita galeriasocial.com",
    scan: "Escanea para abrir en tu teléfono",
  },
};

export default function GaleriaSocialCard({ variant = "wide" }) {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.en;
  const isCompact = variant === "compact";

  return (
    <div
      className={`bg-gradient-to-br from-[#F5A524]/10 via-[#121214]/80 to-[#121214]/80 backdrop-blur-md border border-[#F5A524]/30 rounded-xl ${
        isCompact ? "p-4" : "p-5 sm:p-6"
      }`}
      data-testid="galeria-social-card"
    >
      <div className="flex items-center gap-2 mb-3">
        <ImagesSquare weight="fill" className="w-4 h-4 text-[#F5A524]" />
        <p className="text-[#F5A524] text-[10px] uppercase tracking-[0.18em] font-semibold">
          {c.tag}
        </p>
      </div>

      <div className={`flex ${isCompact ? "flex-col" : "items-center"} gap-4 sm:gap-5`}>
        <div className="shrink-0 bg-white p-2 rounded-lg self-start">
          <QRCode
            value={GALERIA_URL}
            size={isCompact ? 92 : 100}
            level="M"
            bgColor="#FFFFFF"
            fgColor="#0A0A0A"
            data-testid="galeria-social-qr"
          />
        </div>

        <div className="min-w-0 flex-1">
          <h3 className="font-['Outfit'] text-white text-lg sm:text-xl font-semibold mb-1.5 tracking-tight">
            {c.title}
          </h3>
          <p className="text-[#A1A1AA] text-sm leading-relaxed mb-3">{c.subtitle}</p>

          <a
            href={GALERIA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[#F5A524] hover:text-[#F5B041] text-sm font-semibold group transition-colors"
            data-testid="galeria-social-link"
          >
            {c.visit}
            <ArrowUpRight
              weight="bold"
              className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            />
          </a>
          <p className="text-[#71717A] text-[11px] mt-2 italic">{c.scan}</p>
        </div>
      </div>
    </div>
  );
}
